import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "exchange-mobile-overlay" }

import { computed, onBeforeUnmount, onMounted, ref } from 'vue';

import { accountService } from '@exchange/libs/account/service/src';
import { authService } from '@exchange/libs/auth/service/src';

import LoggedOutOverlay from './LoggedOutOverlay.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ExchangeMobileOverlay',
  setup(__props) {

const useShowSpinnerWhileLoginOut = () => {
  const showSpinnerWhileLoginOut = ref(false);
  const onLogoutOnXS = (e) => {
    showSpinnerWhileLoginOut.value = e.detail.doing;
  };

  onMounted(() => {
    window.addEventListener('logout-on-xs', onLogoutOnXS, true);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('logout-on-xs', onLogoutOnXS, true);
  });

  return {
    showSpinnerWhileLoginOut,
  };
};

const hasBeenAuthenticated = computed(() => authService.hasBeenAuthenticated);
const initialLoadAuthIsChecked = computed(() => authService.initialLoadAuthIsChecked);
const { accountUserChecksActionRequired } = accountService;

const { showSpinnerWhileLoginOut } = useShowSpinnerWhileLoginOut();

const overlay = computed(() => {
  if (!initialLoadAuthIsChecked.value || showSpinnerWhileLoginOut.value) {
    return {
      show: true,
      spinner: true,
    };
  }

  if (initialLoadAuthIsChecked.value && !hasBeenAuthenticated.value) {
    return {
      show: true,
      spinner: false,
    };
  }

  if (initialLoadAuthIsChecked.value && hasBeenAuthenticated.value && accountUserChecksActionRequired.value) {
    return {
      show: true,
      spinner: true,
    };
  }

  return {
    show: false,
    spinner: false,
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (overlay.value.show)
      ? (_openBlock(), _createBlock(LoggedOutOverlay, {
          key: 0,
          "show-spinner": overlay.value.spinner
        }, null, 8, ["show-spinner"]))
      : _createCommentVNode("", true)
  ]))
}
}

})